import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { fetchTriggers, toggleTriggerStatus } from './operationsSlice'
import { TRIGGER_TYPE_COLORS } from './types/operations.types'
import { OperationsTabBar } from './components/OperationsTabBar'
import {
  OpsPageWrapper,
  OpsCard,
  OpsCardHeader,
  OpsTable,
  OpsTableHead,
  OpsTableRow,
  Badge,
  MonoText,
  OpsButton,
  opsColors,
} from './styled/Operations.styled'

export const TriggersAndAutomation: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { triggers } = useSelector((state: RootState) => state.operations)

  useEffect(() => {
    dispatch(fetchTriggers())
  }, [dispatch])

  return (
    <OpsPageWrapper>
      <h1 style={{ fontSize: '30px', fontWeight: 900, color: opsColors.textPrimary, margin: 0, fontFamily: 'DM Sans, sans-serif' }}>
        Triggers & Automation
      </h1>

      <OperationsTabBar />

      <OpsCard noPadding>
        <div style={{ padding: '1.25rem 1.25rem 0.5rem' }}>
          <OpsCardHeader>
            <h3>Automation Rules</h3>
          </OpsCardHeader>
        </div>
        <OpsTable>
          <OpsTableHead>
            <tr>
              <th>Trigger Name</th>
              <th>Scope</th>
              <th>Type</th>
              <th>Condition</th>
              <th>Last Fired</th>
              <th>Next Expected</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </OpsTableHead>
          <tbody>
            {triggers?.map((trigger) => (
              <OpsTableRow key={trigger.id}>
                <td>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 700 }}>
                    <span style={{ color: opsColors.brand500 }}>&#9889;</span>
                    {trigger.name}
                  </span>
                </td>
                <td style={{ fontSize: '12px', color: opsColors.textFaded }}>{trigger.scope}</td>
                <td>
                  <Badge bg={TRIGGER_TYPE_COLORS[trigger.type]}>{trigger.type}</Badge>
                </td>
                <td><MonoText>{trigger.condition}</MonoText></td>
                <td style={{ fontSize: '10px', color: opsColors.textFaded }}>
                  {trigger.lastFired ? new Date(trigger.lastFired).toLocaleString() : '-'}
                </td>
                <td style={{ fontSize: '10px', color: opsColors.textFaded }}>
                  {trigger.nextExpected || '-'}
                </td>
                <td>
                  {trigger.enabled ? (
                    <Badge bg={opsColors.successBase}>ON</Badge>
                  ) : (
                    <Badge bg={opsColors.textFaded}>OFF</Badge>
                  )}
                </td>
                <td>
                  {trigger.enabled ? (
                    <OpsButton
                      variant="danger"
                      size="sm"
                      onClick={() => dispatch(toggleTriggerStatus({ id: trigger.id, enabled: false }))}
                    >
                      Disable
                    </OpsButton>
                  ) : (
                    <OpsButton
                      size="sm"
                      onClick={() => dispatch(toggleTriggerStatus({ id: trigger.id, enabled: true }))}
                    >
                      Enable
                    </OpsButton>
                  )}
                </td>
              </OpsTableRow>
            ))}
          </tbody>
        </OpsTable>
      </OpsCard>
    </OpsPageWrapper>
  )
}
